import Cookies from "js-cookie";

const TokenKey = "token";

export function getToken() {
  return localStorage.getItem(TokenKey);
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token);
}

export function removeToken() {
  return localStorage.removeItem(TokenKey);
}

export function removeUserInfo() {
  return localStorage.removeItem("userInfo");
}

export function getUserInfo() {
  return JSON.parse(localStorage.getItem("userInfo"));
}

export function setUserInfo(userInfo) {
  return localStorage.setItem("userInfo", JSON.stringify(userInfo));
}

export function setName(name) {
  return localStorage.setItem("name", name);
}
export function setRole(roleName) {
  return localStorage.setItem("roleName", roleName);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js